import React, { useMemo } from 'react';
import { createPyramidMaterial } from '../materials/wireframeMaterials';

function Pyramid({ position = [0, -0.5, 0], radius = 2, height = 3, segments = 4 }) {
  const material = useMemo(() => {
    const mat = createPyramidMaterial();
    mat.transparent = true;
    mat.opacity = 0; // Start invisible
    return mat;
  }, []);

  return (
    <mesh position={position} name="pyramid-mesh">
      <coneGeometry args={[radius, height, segments, 1]} />
      <primitive object={material} />
    </mesh>
  );
}

export default Pyramid;